import React, { Fragment, Suspense, lazy } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import TravelHero from '../../components/TravelHero/TravelHero';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';

// Lazy load components for better performance
const TravelPackages = lazy(() => import('../../components/TravelPackages/TravelPackages'));
const TravelDestinations = lazy(() => import('../../components/TravelDestinations/TravelDestinations'));
const WinterTours = lazy(() => import('../../components/WinterTours/WinterTours'));
const TravelReviews = lazy(() => import('../../components/TravelReviews/TravelReviews'));
const Newslatter = lazy(() => import('../../components/Newslatter/Newslatter'));

// Loading fallback component
const LoadingFallback = () => (
    <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '200px',
        padding: '40px 0'
    }}>
        <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #FF6B6B',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
        }}></div>
        <style>{`
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `}</style>
    </div>
);

const TravelToursPage = () => {
    return (
        <Fragment>
            <Navbar />
            <TravelHero />
            <Suspense fallback={<LoadingFallback />}>
                <TravelDestinations />
            </Suspense>
            <Suspense fallback={<LoadingFallback />}>
                <TravelPackages />
            </Suspense>
            <Suspense fallback={<LoadingFallback />}>
                <WinterTours />
            </Suspense>
            <Suspense fallback={<LoadingFallback />}>
                <TravelReviews />
            </Suspense>
            <Suspense fallback={null}>
                <Newslatter/>
            </Suspense>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default TravelToursPage;

